const modalModule = {
  state: {
    show: false,
    title: '',
    okText: '',
    cancleText: '',
    onOk: () => {},
    onCancle: () => {},
  },

  mutations: {
    showUnderEnter(state, payload) {
      state.show = true;
      state.title = payload.title;
      state.okText = payload.okText;
      state.cancleText = payload.cancleText;
      state.onOk = payload.onOk;
      state.onCancle = payload.onCancle;
    },
    hideUnderEnter(state, payload) {
      state.show = false;
      state.title = '';
      state.okText = '';
      state.cancleText = '';
      state.onOk = () => {};
      state.onCancle = () => {};
    },
  },

  actions: {
    showUnderEnter({ commit }, payload) {
      commit('showUnderEnter', payload);
    },

    hideUnderEnter({ commit }, payload) {
      commit('hideUnderEnter', payload);
    },

    UnderEnterOnOk({ commit, state }, payload) {
      state.onOk();
      commit('hideUnderEnter', {});
    },

    UnderEnterOnCancle({ commit, state }, payload) {
      state.onCancle();
      commit('hideUnderEnter', {});
    },
  },

  getters: {
    getUnderEnterState: state => {
      return {
        show: state.show,
        title: state.title,
        okText: state.okText,
        cancleText: state.cancleText,
        onOk: state.onOk,
        onCancle: state.onCancle,
      };
    },
  },
};

export default modalModule;



// WEBPACK FOOTER //
// ./src/store/modules/under-renter.js